import { createContext, Dispatch, SetStateAction } from "react";
import { STAKING_STAGES } from "../constants/stages";

interface StageContext {
  stage?: STAKING_STAGES;
  setStage?: Dispatch<SetStateAction<STAKING_STAGES>>;
}

export const StageContext = createContext<StageContext>({});
